(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function resizeAstralRequestButtons() {
    document.querySelectorAll('[data-psh-modal-target="psh-astral-request"].quick-add__button.external_cta_text, [data-psh-modal-target="psh-zodiac-request"].quick-add__button.external_cta_text').forEach((button) => {
      button.style.setProperty('--button-background-color', '#0f4c81', 'important');
      button.style.setProperty('--button-border-color', '#0f4c81', 'important');
      button.style.setProperty('--button-color', '#ffffff', 'important');
      button.style.setProperty('width', 'auto', 'important');
      button.style.setProperty('min-width', window.innerWidth < 750 ? '150px' : '168px', 'important');
      button.style.setProperty('min-height', window.innerWidth < 750 ? '40px' : '42px', 'important');
      button.style.setProperty('padding', window.innerWidth < 750 ? '8px 14px' : '9px 18px', 'important');
      button.style.setProperty('border-radius', '8px', 'important');
      button.style.setProperty('gap', '8px', 'important');
      button.style.setProperty('font-size', window.innerWidth < 750 ? '0.9rem' : '0.95rem', 'important');
      button.style.setProperty('font-weight', '700', 'important');
      button.style.setProperty('line-height', '1.15', 'important');

      const icon = button.querySelector('.add-to-cart-icon');
      if (icon) {
        icon.style.setProperty('width', '16px', 'important');
        icon.style.setProperty('height', '16px', 'important');
        icon.style.setProperty('flex', '0 0 16px', 'important');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', resizeAstralRequestButtons, { once: true });
  window.addEventListener('resize', resizeAstralRequestButtons);
  new MutationObserver(resizeAstralRequestButtons).observe(document.documentElement, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();
})();
